import { z } from "zod";
import { UIElementType } from "../../../AppConstants";
import { t } from "i18next";

const getDeviceTypeSchema = () => {
  return z.object({
    TypeName: z
      .string()
      .min(1, { message: "Type name is required" })
      .describe(JSON.stringify({ elementType: UIElementType.TEXTFIELD, inputLabel: t("deviceTypeList.typeName"), isRequired: true })),
    LongName: z
      .string()
      .min(1, { message: "Long name is required" })
      .describe(JSON.stringify({ elementType: UIElementType.TEXTFIELD, inputLabel: t("deviceTypeList.longName"), isRequired: true }))
  });
};

const getDeviceTypeDefaultValue = (value = null) => {
  return {
    TypeName: value ? value?.TypeName : "",
    LongName: value ? value?.LongName : ""
  };
};

const getDeviceTypeAPIPostSchema = (countryCode, businessCode) => {
  return {
    countryCode: countryCode,
    businessCode: businessCode,
    devicetype: [
      {
        DeviceTypeId: "",
        TypeName: null,
        LongName: null,
        Deleted: false,
        CountryCode: countryCode,
        BusinessCode: businessCode,
      },
    ],
  };
};

const getDeviceTypeAuditInfoSchema = () => {
  return {
    auditInfo: [
      {
        Location: "Device Type",
        LocationKey: "",
        Action: null,
        shortDesc: null,
        currentState: null,
        previousState: null,
      },
    ],
  };
};

export { getDeviceTypeSchema, getDeviceTypeDefaultValue, getDeviceTypeAPIPostSchema, getDeviceTypeAuditInfoSchema };
